import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon as LegacyIcon } from '@ant-design/compatible'

/// UI components
import { Input } from 'antd'

export default class InputField extends Component {
    static propTypes = {
      placeholder: PropTypes.string,
      name: PropTypes.string.isRequired,
      type: PropTypes.string,
      icon: PropTypes.string,
      value: PropTypes.string,
      validate: PropTypes.func,
      onChange: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      'data-testid': PropTypes.string,
    };

    state = {
      value: this.props.value,
      error: false,
    };

    componentWillReceiveProps(update) {
      this.setState({ value: update.value })
    }

    onChange = (e) => {
      const name = this.props.name
      const value = e.target.value
      const error = this.props.validate ? this.props.validate(value) : false
      this.setState({ value, error })

      this.props.onChange({ name, value, error })
    }

    render() {
      return (
            <div className='input-field-container'>
                <Input
                    placeholder={this.props.placeholder}
                    value={this.state.value}
                    prefix={this.props.icon ? <LegacyIcon type={this.props.icon} /> : null}
                    type={this.props.type}
                    onChange={this.onChange}
                    className={this.props.className}
                    disabled={this.props.disabled}
                    data-testid={this.props['data-testid']}
                />
                <span style={{ color: 'red' }}>{ this.state.error }</span>
            </div>
      )
    }
}
